import SuperFetchV2 from '../../superFetchV2';
import {
  PgProviderFeeHistoriesFindResponse,
  PgProviderFeesFindResponse,
  PgProviderFeesUpdateRequest,
  PgProviderFeesUpdateResponse,
} from './types';

const BASE = '/pg-provider-fees';
const requestOptions = { skipFullscreenLoader: true, skipErrorModal: true };

export const pgProviderFeeApi = {
  getFees: (): Promise<PgProviderFeesFindResponse> =>
    SuperFetchV2.get<unknown, PgProviderFeesFindResponse>(BASE, requestOptions),
  getHistories: (limit = 50): Promise<PgProviderFeeHistoriesFindResponse> =>
    SuperFetchV2.get<unknown, PgProviderFeeHistoriesFindResponse>(BASE + '/histories', {
      ...requestOptions,
      params: { limit },
    }),
  updateFees: (body: PgProviderFeesUpdateRequest): Promise<PgProviderFeesUpdateResponse> =>
    SuperFetchV2.put<unknown, PgProviderFeesUpdateResponse>(BASE, body, requestOptions),
};
